// import React, { useEffect, useState, useMemo } from 'react';
// import {
//   defaultFormTemplate,
//   directSchemaTemplate,
//   columnLabels,
//   fieldOverrides,
//   validationRules,
//   infoIcons,
//   layout
// } from '../API/ProductSchema';
// import { API_BASE_URL } from 'config';
// import { useProductCreateStore } from '../store/useProductCreateStore';
// import { fetchCustomFieldsByMenuId } from '@utils/customFields';
// import PreBuildFormNew from '@components/form-elements/PreBuidFormNew';
// import { fetchJson, useGetMetaData, useMatchedMenu } from '@utils/fetchJson';
// import { toast } from 'react-toastify';
// import { Plug } from 'lucide-react';
// const CreateProduct = ({ onClose, onSave }) => {
//   // This is used to get menuid from the module name /link
//   const menuId = useMatchedMenu('products');
//   // use this function to get the module metadata
//   const  menuData = useGetMetaData('products');
//   // This is use to open create module globally. Payload use to trasfer the data
//   const { isOpen, payload: payloadWrapper, close } = useProductCreateStore();
//   const payload = payloadWrapper?.payload || payloadWrapper || {};
  
//   // use this to set default fields for the module
//   const [defaultFormData, setDefaultFormData] = useState(defaultFormTemplate);
//   // memorise the default data to rerender againa and again
//   //const memoFormData = useMemo(() => defaultFormData, [defaultFormData]);
  
//   //Note: Merage all custoom feilds with default
//   const [mergedFieldOverrides, setMergedFieldOverrides] = useState(fieldOverrides);
//   const [mergedValidationRules, setMergedValidationRules] = useState(validationRules);
//   const [mergedColumnLabels, setMergedColumnLabels] = useState(columnLabels);
//   const [mergedSchemaTemplate, setMergedSchemaTemplate] = useState(directSchemaTemplate);
//   const [mergedLayout, setMergedLayout] = useState(layout);
//   const [customFields, setCustomFields] = useState([]);
//   const [initialData, setInitialData] = useState(false);
// // this useEffect use to get all the dynamic and statis fields from the server and update default values  
// useEffect(() => {
//   if (!isOpen || !menuId) return;
//   const loadFields = async () => {
//     try {
//       const {
//         injectedLayout,
//         customFields,
//         extendedDefaults,
//         extendedValidations,
//         extendedLabels,
//         extendedOverrides,
//         extendedSchema,
//         generatedLayout
//       } = await fetchCustomFieldsByMenuId(menuId, menuData, {
//         defaultFormTemplate,
//         validationRules,
//         fieldOverrides,
//         columnLabels,
//         directSchemaTemplate,
//         layout,
//         autoInjectLayout: true,
//       });
    
//       setCustomFields(customFields);
//       setDefaultFormData(extendedDefaults);
//       setMergedValidationRules(extendedValidations);
//       setMergedColumnLabels(extendedLabels);
//       setMergedFieldOverrides(extendedOverrides);
//       setMergedSchemaTemplate(extendedSchema);
//       setMergedLayout(injectedLayout);
//     } catch (err) {
//       toast.error('Failed to load custom fields');
//     }
//   };
//   loadFields();
//   console.log("from create",menuData);
// }, [menuId, isOpen,menuData]);

// // This function used to get the record details for edit mode.
// useEffect(() => {
//   const fetchRecordDetails = async () => {
//     if (payload?.record_id) {
//       try {
//         const res = await fetchJson(`${API_BASE_URL}/productMaster/${payload.record_id}?menuId=${menuId}`, {
//           method: 'GET',
//         });

//         const recordData = res?.data?.[0] || {};
//         console.log('Fetched task data:', recordData);

//         const resData = {
//           ...defaultFormTemplate,
//           ...recordData,
//           menuId,
//         };
//         setDefaultFormData((prev) => ({
//           ...prev,
//           ...resData,
//           menuId,
//         }));
        
//       } catch (err) {
//         console.error('Error fetching task:', err);
//         setDefaultFormData({ ...defaultFormTemplate, menuId });
//       }
//     } else {
//       console.log("Creating new task — resetting form");
//       setDefaultFormData({
//         ...defaultFormTemplate,
//         menuId,
//       });
//     }
//     setInitialData(true); // only for UI/conditional logic, not as a trigger
//   };

//   fetchRecordDetails();
// }, [payload?.record_id, menuId]);

//   const handleSubmit = async (resetAfter = false) => {
//     // Handle save
//   };
//   if (!isOpen) return null;
  
//   // PreBuildFormNew use to create form for the module.
//   /*
//   * directSchema : used to show form feilds
//   * getDefApi this is used to get the datatabel feilds details like name,type default value etc.
//   * saveApi : this is used to save the data
//   * updateApi : use to update the record.
//   * formDataPre: this is the form data
//   * primaryKey: this identified the which is the primary key for module.
//   * sidebarSize : this is used to define the module sixe. lg is large. md is medium
//   * title : this is used to show the from title
//   * onClose : do action on close.
//   * skipFields : this is used to skip the feilds.
//   * fieldOverrides : if you want to add new module or override any filed behaviour use this.
//   * validationRules : add form validation
//   * labels: if you want to override the lable use this.
//   * editId : this is used to identified the edit key
//   * recordId: this is used to identified the primary key.
//   */

//   return (
//     <>
//     <PreBuildFormNew
//       menuId={menuId}
//       directSchema={mergedSchemaTemplate}
//       getDefApi={`${API_BASE_URL}/getDefinations`}
//       saveApi={`${API_BASE_URL}/rentalproductMaster`}
//       updateApi={`${API_BASE_URL}/rentalproductMaster/${defaultFormData?.product_id}`}
//       //formDataPre={memoFormData}
//       formData={defaultFormData}
//       setFormData={setDefaultFormData}
//       primaryKey="product_id"
//       sidebarSize="lg"
//       title="Create Product"
//       onClose={() => close()}
//       skipFields={['created_by', 'created_date']}
//       fieldOverrides={mergedFieldOverrides}
//       validationRules={mergedValidationRules}
//       labels={mergedColumnLabels}
//       infoIcons={infoIcons}
//       layout={mergedLayout}
//       editId={defaultFormData?.product_id}
//       recordId={defaultFormData?.product_id}
//     />
//   </>
//   );
// };
// export default CreateProduct;




import React, { useEffect, useState, useMemo } from 'react';
import {
  defaultFormTemplate,
  directSchemaTemplate,
  columnLabels,
  fieldOverrides,
  validationRules,
  skipFields,
  infoIcons,
  layout
} from '../API/ProductSchema';
import { API_BASE_URL } from 'config';
import { useCategoryCreateStore, useProductCreateStore } from '../store/useProductCreateStore';
import { fetchCustomFieldsByMenuId } from '@utils/customFields';
import PreBuildFormNew from '@components/form-elements/PreBuidFormNew';
import { fetchJson, useGetMetaData, useMatchedMenu } from '@utils/fetchJson';
import { toast } from 'react-toastify';
import FormSkeleton from '@components/form-elements/FormSkeleton';
const CreateProduct = ({ onClose, onSave }) => {
  // This is used to get menuid from the module name /link
  const menuId = useMatchedMenu('products');
  // use this function to get the module metadata
  const  menuData = useGetMetaData('products');
  // This is use to open create module globally. Payload use to trasfer the data
  const { isOpen, payload: payloadWrapper, close } = useProductCreateStore();
  //const payload = payloadWrapper?.payload || payloadWrapper || {};
  const payload = useMemo(
  () => payloadWrapper?.payload || payloadWrapper || {},
  [payloadWrapper]
  );
  
  // use this to set default fields for the module
  const [defaultFormData, setDefaultFormData] = useState(defaultFormTemplate);
  const memoFormData = useMemo(() => defaultFormData, [defaultFormData]);
  // memorise the default data to rerender againa and again
  
  //Note: Merage all custom feilds with default
  const [mergedFieldOverrides, setMergedFieldOverrides] = useState(fieldOverrides);
  const [mergedValidationRules, setMergedValidationRules] = useState(validationRules);
  const [mergedColumnLabels, setMergedColumnLabels] = useState(columnLabels);
  const [mergedSchemaTemplate, setMergedSchemaTemplate] = useState(directSchemaTemplate);
  const [mergedLayout, setMergedLayout] = useState(layout);
  const [customFields, setCustomFields] = useState([]);
  const [initialData, setInitialData] = useState(false);
  
  // use this to overrite any feild
  const customeModules ={
  }
  // use this to set default data and edit record data.
  useEffect(() => {
    const setupFormData = async () => {
      // 1. Editing existing record
      if (payload?.record_id) {
        setInitialData(false);
        try {
          const res = await fetchJson(`${API_BASE_URL}/rentalproductMaster/${payload.record_id}?menuId=${menuId}`, {
            method: 'GET',
          });
          const recordData = res?.data?.[0] || {};
          setDefaultFormData(prev => ({...prev,...payload,...recordData,menuId,}));
        } catch (err) {
          setDefaultFormData(prev => ({...prev,...payload, menuId }));
        }
        setInitialData(true);
      }
      else {
        // 2. Creating new record
        setDefaultFormData(prev => ({...prev,...payload, menuId }));
        setInitialData(true);
      }
    };
    setupFormData();
  }, [payload, menuId]);


// this useEffect use to get all the dynamic and statis fields from the server and update default values 
useEffect(() => {
  if (!isOpen || !menuId) return;

  const loadFields = async () => {
    try {
      const {
        injectedLayout,
        customFields,
        extendedDefaults,
        extendedValidations,
        extendedLabels,
        extendedOverrides,
        extendedSchema,
        generatedLayout
      } = await fetchCustomFieldsByMenuId(menuId, menuData, {
        defaultFormTemplate,
        validationRules,
        fieldOverrides,
        columnLabels,
        directSchemaTemplate,
        layout,
        autoInjectLayout: true,
      });

      setCustomFields(customFields);
      setMergedValidationRules(extendedValidations);
      setMergedColumnLabels(extendedLabels);
      setDefaultFormData(prev => ({
        ...extendedDefaults,
        ...prev,
      }));
      setMergedFieldOverrides(extendedOverrides);
      setMergedSchemaTemplate(extendedSchema);
      setMergedLayout(injectedLayout);
    } catch (err) {
      toast.error('Failed to load custom fields');
    }
  };
  loadFields();
}, [isOpen, menuId, menuData, payload?.parent_id, payload?.is_parent]);

const updateData = (updater) => {
  console.log(updater);
  setDefaultFormData(prev => {
    const next = typeof updater === 'function' ? updater(prev) : updater;
    return next;
  });
};
  if (!isOpen) return null;
  const loading = payload?.record_id && !initialData;

  return (
    <> {loading ? (
      <div className='modal-panel size-lg fixed top-[50px] right-0 h-[calc(100vh-56px)] bg-white shadow-lg z-50 flex flex-col w-screen max-w-full md:w-full md:w-[700px]'>
      <FormSkeleton /> </div>
    ) : (
    <PreBuildFormNew
      menuId={menuId}
      directSchema={mergedSchemaTemplate}
      getDefApi={`${API_BASE_URL}/getDefinations`}
      saveApi={`${API_BASE_URL}/rentalproductMaster`}
      updateApi={`${API_BASE_URL}/rentalproductMaster/${memoFormData?.product_id}`}
      //formDataPre={memoFormData}
      formData={defaultFormData}
      setFormData={updateData}
      primaryKey="product_id"
      sidebarSize="lg"
      title="Create Product"
      onClose={() =>{ setDefaultFormData(defaultFormTemplate);close()}}
      skipFields={skipFields}
      fieldOverrides={mergedFieldOverrides}
      validationRules={mergedValidationRules}
      labels={mergedColumnLabels}
      infoIcons={infoIcons}
      layout={mergedLayout}
      editId={memoFormData?.product_id}
      recordId={memoFormData?.product_id}
      customModules={(customeModules ? customeModules : {})}
    />
    )}
  </>
  
  );
};
export default CreateProduct;